module.exports = __webpack_public_path__ + "static/profile-pic-76d9d29ee1aa8ec101c736e462266e10.jpg";